export default __webpack_public_path__ + "static/media/featured_tour_08.3208eb32.png";